import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserService } from 'user';
import { ApiUser } from '@tytapp/api';

@Component({
  selector: 'app-confirmation-account',
  templateUrl: './confirmation-account.component.html',
  styleUrls: ['./confirmation-account.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmationAccountComponent implements OnInit {

  constructor(
    private userService : UserService
  ) { }

  user : ApiUser;
  
  get confirmationText() {
    if (this.user && this.user.membership && this.user.membership.product && this.user.membership.product.confirmation_message) {
      return this.user.membership.product.confirmation_message;
    } 
    return '<div style="text-align: center;">Your membership gets you a full ad-free experience, access to all of our videos and podcasts and help support</div>';
  }

  ngOnInit() {
    this.userService.userChanged.subscribe(user => this.user = user);
  }

}
